<template>
    <div>
        <div>
            <div v-show="showMap && loadHome == false" class="row px-3">
                <form-input-group
                    class="px-0"
                    type="search"
                    v-model="search"
                    btn-class="btn input-group-text border-left-0 p-2 bg-white"
                    icon-btn="mdi mdi-magnify mdi-18px"
                    placeholder="Buscar endereço ou Responsável familiar"
                    @submit="filtrarResultados"
                    @input="filtrarResultados"
                    :grid="filtroShow ? '9' : '12'"
                />
                <div v-if="filtroShow" class="col-md-3 col-sm-12 pr-0">
                    <button
                        class="btn btn-sm btn-default btn-block mx-0 mb-3 px-2 py-1 d-flex align-items-center"
                        @click="showFiltro = !showFiltro"
                    >
                        <i
                            class="mdi mdi-18px"
                            :class="
                                showFiltro ? 'mdi-filter-off' : 'mdi-filter'
                            "
                        ></i>
                        {{
                            showFiltro ? "Esconder filtros" : "Mostrar filtros"
                        }}
                    </button>
                </div>
            </div>
            <div class="col-12 px-0" v-show="showFiltro && loadHome == false">
                <Filtro
                    @cor="filtrarMarcadores"
                    @sexo="filtrarMarcadores"
                    @situacao_rua="filtrarMarcadores"
                    @trabalho_infantil="filtrarMarcadores"
                    @programa_social="filtrarMarcadores"
                    @idoso="filtrarMarcadores"
                    @idade="filtrarMarcadores"
                    @limpar="ClearFilter"
                    @limpo="clearFiltrosData = false"
                    :limpar="clearFiltrosData"
                    :aba="aba"
                    :programas="programas"
                />
            </div>
            <div class="col-12 px-0" v-if="loadHome == false">
                <Header :dados="marcadores" :aba="aba" />
            </div>
            <div
                v-show="showMap"
                id="mapContainer"
                :style="'height:' + height + ' width: 100%'"
                ref="hereMap"
            ></div>
            <div
                class="row px-3 py-2 d-flex justify-content-end"
                v-show="showMap"
            >
                <button
                    class="btn btn-primary btn-sm mb-0"
                    v-if="!showMap"
                    @click="print"
                >
                    <i class="mdi mdi-printer mdi-18px" />
                </button>
                <button
                    class="btn btn-danger btn-sm m-0"
                    v-if="!showMap"
                    @click="
                        showMap = true;
                        reloadMap;
                    "
                >
                    <i class="mdi mdi-close mdi-18px" />
                </button>
            </div>
            <div v-show="!showMap" id="boxPrint" ref="boxPrint">
                <img :src="imagem" alt="" width="100%" />
                <div id="panel"></div>
                <Show v-if="botaoimprimir != 'none'" :dados="markers" />
            </div>

            <div
                class="row px-3 py-2 d-flex justify-content-end"
                :style="'display:' + botaoimprimir + '!important;'"
            >
                <button
                    class="btn btn-default m-0 btn-sm"
                    v-if="showMap"
                    @click="gerarImagemMapa"
                >
                    <i class="mdi mdi-text-box-check-outline mdi-18px" /> Gerar
                    PDF
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Show from "../Show";
import Filtro from "./Filtro";
import Header from "./Header";
export default {
    name: "HereMap",
    components: { Show, Filtro, Header },
    props: {
        center: Object,
        // center object { lat: 40.730610, lng: -73.935242 }
        markers: Array,
        programas: Array,
        icon: String,
        aba: String,
        botaoimprimir: {
            type: String,
            default: "block",
        },
        height: {
            type: String,
            default: "600px;",
        },
        filtroShow: {
            type: Boolean,
            default: false,
        },
        loadHome: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        icon() {
            this.ClearFilter();
            this.reloadMap();
        },
        markers() {
            this.marcadores = this.markers;
            this.marcadoresTemp = this.markers;
            this.centro = this.center;
            this.centroTemp = this.center;
            this.ClearFilter();
            this.reloadMap();
        },
    },
    data() {
        return {
            search: "",
            showMap: true,
            showFiltro: false,
            clearFiltrosData: false,
            platform: null,
            marcadoresTemp: "",
            marcadores: "",
            centro: "",
            centroTemp: "",
            map: "",
            ui: "",
            service: "",
            imagem: "",
            filtros: {
                cor: "",
                sexo: "",
                situacao_rua: "",
                trabalho_infantil: "",
                programa_social: "",
                idoso: "",
                idade: "",
            },
            url: window.urlbase,
            apikey: "RZEvC1q3oAPoLsE6va3ywgOIkP0QmEPo4AVigeXPGvc",
            // apikey: "7dwdqDBhp9NWZ8HpC7KGWBnulJ7aRRwJk6MnC1NsCLg",
            // You can get the API KEY from developer.here.com
        };
    },
    async mounted() {
        this.marcadores = this.markers;
        this.marcadoresTemp = this.markers;
        this.centro = this.center;
        this.centroTemp = this.center;
        //console.log(this.markers);

        // Initialize the platform object:
        const platform = new window.H.service.Platform({
            apikey: this.apikey,
        });
        this.platform = platform;

        this.service = this.platform.getSearchService();

        this.initializeHereMap();
        this.setInteractive(this.map);
        this.addContextMenus(this.map);
        this.addInfoBubble(this.map);
        this.showGeoJSONData(this.map);
        // this.startClustering(this.marcadores);
        // this.getLocation();
    },
    methods: {
        ClearFilter() {
            this.marcadores = this.marcadoresTemp;
            this.centro = this.centroTemp;
            this.filtros = {
                cor: "",
                sexo: "",
                situacao_rua: "",
                trabalho_infantil: "",
                idoso: "",
                idade: "",
                programa_social: "",
            };
            this.clearFiltrosData = true;
            this.reloadMap();
        },
        filterMarcadoresMembros(i) {
            if (this.filtros["cor"] != "" && this.filtros["idoso"] == 1) {
                return (
                    parseInt(i.cor_raca) == this.filtros["cor"] &&
                    parseInt(i.idade) > 60
                );
            } else if (this.filtros["cor"] != "") {
                return parseInt(i.cor_raca) == this.filtros["cor"];
            } else if (this.filtros["idoso"] == 1) {
                return parseInt(i.idade) > 60;
            } else if (this.filtros["idade"] != "") {
                let idade = parseInt(i.idade);
                // //console.log(idade);
                // //console.log(this.filtros["idade"]);
                // //console.log(
                //     idade >= this.filtros["idade"][0] &&
                //         idade <= this.filtros["idade"][1]
                // );
                return (
                    idade >= this.filtros["idade"][0] &&
                    idade <= this.filtros["idade"][1]
                );
            } else {
                return true;
            }
        },
        filtrarMarcadores(value) {
            this.marcadores = this.marcadoresTemp;

            let key = Object.keys(value)[0];
            this.filtros[key] = value[key];
            //console.log(value);
            //console.log(key);
            //console.log(this.filtros);

            this.marcadores = this.marcadores.filter((item) => {
                let responsavel_familiar = item.dados.responsavel_familiar;
                let sexo = "";
                let idade = "";
                let situacao_rua = parseInt(item.dados.situacao_rua) ?? null;
                let programa_social = item.dados.programa_social ?? null;
                let trabalho_infantil =
                    parseInt(item.dados.trabalho_infantil) ?? null;

                if (responsavel_familiar) {
                    sexo = parseInt(item.dados.responsavel_familiar.sexo);
                }
                // let membros = item.dados.membros;
                let membros = item.dados.membros.filter((i) => {
                    return this.filterMarcadoresMembros(i);
                });

                if (this.filtros["sexo"] != "") {
                    if (sexo == this.filtros["sexo"]) {
                        membros = item.dados.membros.filter((i) => {
                            return this.filterMarcadoresMembros(i);
                        });
                        return membros.length > 0 ? true : false;
                    } else {
                        return false;
                    }
                } else if (this.filtros["cor"] != "") {
                    membros = item.dados.membros.filter((i) => {
                        return this.filterMarcadoresMembros(i);
                    });
                    return membros.length > 0 ? true : false;
                } else if (this.filtros["situacao_rua"] != "") {
                    if (situacao_rua) {
                        membros = item.dados.membros.filter((i) => {
                            return this.filterMarcadoresMembros(i);
                        });
                        return membros.length > 0 ? true : false;
                    } else {
                        return false;
                    }
                } else if (this.filtros["programa_social"] != "") {
                    if (programa_social) {
                        //console.log(this.filtros["programa_social"]);
                        return (
                            programa_social == this.filtros["programa_social"]
                        );
                    } else {
                        return false;
                    }
                } else if (this.filtros["idade"]) {
                    membros = item.dados.membros.filter((i) => {
                        return this.filterMarcadoresMembros(i);
                    });
                    return membros.length > 0 ? true : false;
                } else if (this.filtros["trabalho_infantil"] != "") {
                    if (trabalho_infantil == 1) {
                        membros = item.dados.membros.filter((i) => {
                            return this.filterMarcadoresMembros(i);
                        });
                        return membros.length > 0 ? true : false;
                    } else {
                        return false;
                    }
                } else if (
                    this.filtros["sexo"] != "" &&
                    this.filtros["situacao_rua"] != "" &&
                    this.filtros["trabalho_infantil"] != ""
                ) {
                    if (
                        situacao_rua &&
                        trabalho_infantil == 1 &&
                        sexo == this.filtros["sexo"]
                    ) {
                        membros = item.dados.membros.filter((i) => {
                            return this.filterMarcadoresMembros(i);
                        });
                        return membros.length > 0 ? true : false;
                    } else {
                        return false;
                    }
                } else if (
                    (this.filtros["sexo"] != "" &&
                        this.filtros["situacao_rua"] != "") ||
                    this.filtros["trabalho_infantil"] != ""
                ) {
                    if (
                        situacao_rua ||
                        (trabalho_infantil == 1 && sexo == this.filtros["sexo"])
                    ) {
                        membros = item.dados.membros.filter((i) => {
                            return this.filterMarcadoresMembros(i);
                        });
                        return membros.length > 0 ? true : false;
                    } else {
                        return false;
                    }
                } else if (
                    this.filtros["sexo"] != "" ||
                    (this.filtros["situacao_rua"] != "" &&
                        this.filtros["trabalho_infantil"] != "")
                ) {
                    if (
                        (situacao_rua && trabalho_infantil == 1) ||
                        sexo == this.filtros["sexo"]
                    ) {
                        membros = item.dados.membros.filter((i) => {
                            return this.filterMarcadoresMembros(i);
                        });
                        return membros.length > 0 ? true : false;
                    } else {
                        return false;
                    }
                } else if (
                    (this.filtros["sexo"] != "" ||
                        this.filtros["situacao_rua"] != "" ||
                        (this.filtros["trabalho_infantil"] != "" &&
                            this.filtros["trabalho_infantil"] == 1) ||
                        this.filtros["idade"] != "") &&
                    this.filtros["programa_social"] != ""
                ) {
                    membros = item.dados.membros.filter((i) => {
                        return this.filterMarcadoresMembros(i);
                    });

                    if (
                        this.filtros["programa_social"] &&
                        programa_social == this.filtros["programa_social"]
                    ) {
                        return membros.length > 0 ? true : false;
                    }
                }

                return membros.length > 0;
            });
            this.reloadMap();
        },
        filtrarResultados() {
            if (this.search != "") {
                this.marcadores = this.marcadores.filter((item) => {
                    // item.membros.forEach(elem => {
                    //     return elem.nome_completo
                    //         .toLowerCase()
                    //         .includes(this.search.toLowerCase());
                    // });

                    if (item.dados.responsavel_familiar != null) {
                        let marker =
                            item.dados.responsavel_familiar.nome_completo
                                .toLowerCase()
                                .includes(this.search.toLowerCase());
                        if (marker) {
                            return marker;
                        } else {
                            if (item.dados.nome_logradouro) {
                                return false;
                            } else {
                                return item.dados.nome_logradouro
                                    .toLowerCase()
                                    .includes(this.search.toLowerCase());
                            }
                        }
                    } else {
                        if (item.dados.nome_logradouro) {
                            return false;
                        } else {
                            return item.dados.nome_logradouro
                                .toLowerCase()
                                .includes(this.search.toLowerCase());
                        }
                    }
                });
                this.centro = {
                    lat: this.marcadores[0].lat,
                    lng: this.marcadores[0].lng,
                };
            } else {
                this.marcadores = this.marcadoresTemp;
                this.centro = this.centroTemp;
            }
            this.reloadMap();
        },
        initializeHereMap() {
            const mapContainer = this.$refs.hereMap;
            const H = window.H;

            if (!mapContainer || !H || !this.platform) {
                console.warn("Mapa não inicializado: dependências ausentes.", {
                    mapContainer,
                    H,
                    platform: this.platform,
                });
                return;
            }

            const maptypes = this.platform.createDefaultLayers({
                lg: "pt",
            });

            let center = null;

            const latCentro = Number(this.centro && this.centro.lat);
            const lngCentro = Number(this.centro && this.centro.lng);

            if (Number.isFinite(latCentro) && Number.isFinite(lngCentro)) {
                center = new H.geo.Point(latCentro, lngCentro);
            }

            if (!center && Array.isArray(this.marcadores)) {
                const primeiroMarcadorValido = this.marcadores.find((item) => {
                    const lat = Number(item.lat);
                    const lng = Number(item.lng);

                    return Number.isFinite(lat) && Number.isFinite(lng);
                });

                if (primeiroMarcadorValido) {
                    center = new H.geo.Point(
                        Number(primeiroMarcadorValido.lat),
                        Number(primeiroMarcadorValido.lng)
                    );
                }
            }

            if (!center) {
                console.warn("Centro do mapa inválido. Usando fallback.", {
                    centro: this.centro,
                    marcadores: this.marcadores,
                });

                center = new H.geo.Point(-23.55052, -46.633308);
            }

            this.map = new H.Map(mapContainer, maptypes.vector.normal.map, {
                zoom: 10,
                center,
                pixelRatio: window.devicePixelRatio || 1,
            });

            addEventListener("resize", () => this.map.getViewPort().resize());

            new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map));

            this.ui = H.ui.UI.createDefault(this.map, maptypes, "pt-BR");
        },
        reloadMap() {
            document.getElementById("mapContainer").innerHTML = "";
            this.initializeHereMap();
            // if (this.marcadores && this.marcadores.length > 0) {
            // 	this.setMarker(this.marcadores, this.map);
            // }
            this.addInfoBubble(this.map);

            // this.startClustering(this.marcadores);
        },
        setMarker(markers, map) {
            // Define a variable holding SVG mark-up that defines an icon image:
            var svgMarkup =
                '<svg width="24" height="24" ' +
                'xmlns="http://www.w3.org/2000/svg">' +
                '<rect stroke="white" fill="#1b468d" x="1" y="1" width="22" ' +
                'height="22" /><text x="12" y="18" font-size="12pt" ' +
                'font-family="Arial" font-weight="bold" text-anchor="middle" ' +
                'fill="white">H</text></svg>';

            // Create an icon, an object holding the latitude and longitude, and a marker:
            // var icon = new H.map.Icon(svgMarkup),
            // 	coords = { lat: 40.73061, lng: -73.935242 },
            // 	marker = new H.map.Marker(coords, { icon: icon });
            markers.forEach((element) => {
                var icon = new H.map.Icon(this.icon),
                    coords = { lat: element.lat, lng: element.lng },
                    marker = new H.map.Marker(coords, { icon: icon });

                var html =
                    '<div><a href="http://suasfacil.host/dashboard/familias/edit/5844" target="_blank">teste</a></div><div>City of Manchester Stadium<br />Capacity: 55,097</div>';
                marker.setData(html);

                map.addObject(marker);
                map.setCenter(coords);
            });
            // Add the marker to the map and center the map at the location of the marker:
            // map.addObject(marker);
            // map.setCenter(coords);
        },
        gerarImagemMapa() {
            this.showMap = false;
            this.capture(this.map, this.ui);
            // this.print();
        },
        print() {
            const modal = document.getElementById("boxPrint");
            const cloned = modal.cloneNode(true);
            let section = document.getElementById("print");

            if (!section) {
                section = document.createElement("div");
                section.id = "print";
                document.body.appendChild(section);
            }

            section.innerHTML = "";
            section.appendChild(cloned);
            window.print();
        },
        capture(map, ui) {
            var resultContainer = document.getElementById("panel");
            // Capturing area of the map is asynchronous, callback function receives HTML5 canvas
            // element with desired map area rendered on it.
            // We also pass an H.ui.UI reference in order to see the ScaleBar in the output.
            // If dimensions are omitted, whole veiw port will be captured
            map.capture(
                (canvas) => {
                    if (canvas) {
                        var image = canvas.toDataURL();
                        this.imagem = image;
                        // resultContainer.innerHTML = "";
                        // resultContainer.appendChild(canvas);
                    } else {
                        // For example when map is in Panorama mode
                        resultContainer.innerHTML =
                            "Capturing is not supported";
                    }
                },
                [ui],
                0,
                0,
                resultContainer.offsetWidth,
                resultContainer.offsetWidth
            );
        },
        setInteractive(map) {
            // get the vector provider from the base layer
            var provider = map.getBaseLayer().getProvider();

            // get the style object for the base layer
            var style = provider.getStyle();

            var changeListener = (evt) => {
                if (style.getState() === H.map.Style.State.READY) {
                    style.removeEventListener("change", changeListener);

                    // enable interactions for the desired map features
                    style.setInteractive(
                        ["places", "places.populated-places"],
                        true
                    );

                    // add an event listener that is responsible for catching the
                    // 'tap' event on the feature and showing the infobubble
                    provider.addEventListener("tap", this.onTap);
                }
            };
            style.addEventListener("change", changeListener);
        },
        onTap(evt) {
            var bubble;
            // calculate infobubble position from the cursor screen coordinates
            let position = this.map.screenToGeo(
                evt.currentPointer.viewportX,
                evt.currentPointer.viewportY
            );
            // read the properties associated with the map feature that triggered the event
            let props = evt.target.getData().properties;

            // create a content for the infobubble
            let content =
                '<div style="width:250px"><b>' +
                props.name +
                "</b>" +
                (props.population
                    ? "<br /> População: " + props.population
                    : "") +
                "</div>";

            // Create a bubble, if not created yet
            if (!bubble) {
                bubble = new H.ui.InfoBubble(position, {
                    content: content,
                });
                this.ui.addBubble(bubble);
            } else {
                // Reuse existing bubble object
                bubble.setPosition(position);
                bubble.setContent(content);
                bubble.open();
            }
        },
        startClustering(data) {
            // First we need to create an array of DataPoint objects,
            // for the ClusterProvider
            var dataPoints = data.map(function (item) {
                return new H.clustering.DataPoint(item.lat, item.lng);
            });

            // Create a clustering provider with custom options for clusterizing the input
            var clusteredDataProvider = new H.clustering.Provider(dataPoints, {
                clusteringOptions: {
                    // Maximum radius of the neighbourhood
                    eps: 32,
                    // minimum weight of points required to form a cluster
                    minWeight: 2,
                },
            });

            // Create a layer tha will consume objects from our clustering provider
            var clusteringLayer = new H.map.layer.ObjectLayer(
                clusteredDataProvider
            );

            // To make objects from clustering provder visible,
            // we need to add our layer to the map
            this.map.addLayer(clusteringLayer);
        },

        addContextMenus(map) {
            // First we need to subscribe to the "contextmenu" event on the map
            map.addEventListener("contextmenu", function (e) {
                // As we already handle contextmenu event callback on circle object,
                // we don't do anything if target is different than the map.
                if (e.target !== map) {
                    return;
                }

                // "contextmenu" event might be triggered not only by a pointer,
                // but a keyboard button as well. That's why ContextMenuEvent
                // doesn't have a "currentPointer" property.
                // Instead it has "viewportX" and "viewportY" properties
                // for the associates position.

                // Get geo coordinates from the screen coordinates.
                var coord = map.screenToGeo(e.viewportX, e.viewportY);
                // In order to add menu items, you have to push them to the "items"
                // property of the event object. That has to be done synchronously, otherwise
                // the ui component will not contain them. However you can change the menu entry
                // text asynchronously.
                e.items.push(
                    // Create a menu item, that has only a label,
                    // which displays the current coordinates.
                    new H.util.ContextItem({
                        label: [
                            Math.abs(coord.lat.toFixed(4)) +
                                (coord.lat > 0 ? "N" : "S"),
                            Math.abs(coord.lng.toFixed(4)) +
                                (coord.lng > 0 ? "E" : "W"),
                        ].join(" "),
                    }),
                    // Create an item, that will change the map center when clicking on it.
                    new H.util.ContextItem({
                        label: "Center map here",
                        callback: function () {
                            map.setCenter(coord, true);
                        },
                    })
                );
            });
        },
        addMarkerToGroup(group, coordinate, html) {
            const lat = Number(coordinate && coordinate.lat);
            const lng = Number(coordinate && coordinate.lng);

            if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
                console.warn("Marcador ignorado por coordenada inválida:", coordinate);
                return;
            }

            var icone = new H.map.Icon(this.icon);

            var marker = new H.map.Marker(
                { lat, lng },
                { icon: icone }
            );

            marker.setData(html);
            group.addObject(marker);
        },
        getHtmlpopUp(element) {
            var vul = "";
            var violacao = "";
            var faixa_etaria = "";
            if (element.dados) {
                if (
                    element.dados.vulnerabilidades != null ||
                    (Array.isArray(element.dados.vulnerabilidades) &&
                        element.dados.vulnerabilidades != [])
                ) {
                    element.dados.vulnerabilidades
                        ? element.dados.vulnerabilidades.forEach((el) => {
                              vul += `<li>${el}</li>`;
                          })
                        : "";
                }
                element.dados.violacao
                    ? element.dados.violacao.forEach((el) => {
                          violacao += `<li>${el}</li>`;
                      })
                    : "";

                element.dados.faixa_etaria
                    ? element.dados.faixa_etaria.forEach((el) => {
                          faixa_etaria += `<li>${el}</li>`;
                      })
                    : "";

                return element.dados
                    ? `<div>
                    <b>Responsável Familiar</b>
                    <a ${this.$store.state.user.role_details.name != 'Nível Básico' ? 'href="${this.url}dashboard/familias/edit/${element.dados ? element.dados.id : ""}"' : ''} target="_blank">
                    <br>${
                        element.dados.responsavel_familiar
                            ? element.dados.responsavel_familiar.nome_completo
                            : ""
                    }
                    </a>
                    </div>
                    <div>
                    Quantidades de membros na familia: <b>${
                        element.dados.membros
                            ? element.dados.membros_count
                            : "0"
                    }</b><br>
                    ${
                        element.dados.vulnerabilidades
                            ? "<b>Vulnerabilidade(s)</b><br><ul>" +
                              vul +
                              "</ul><br>"
                            : ""
                    }
                    ${
                        element.dados.violacao
                            ? "<b>Situação de Violação</b><br><ul>" +
                              violacao +
                              "</ul><br>"
                            : ""
                    }
                    ${
                        element.dados.programa_social
                            ? "<b>Programas Sociais</b><br>" +
                              element.dados.programa_social
                            : ""
                    }
                    </div>${
                        element.dados.faixa_etaria
                            ? "<b>Faixa Etária</b><br><ul>" +
                              faixa_etaria +
                              "</ul><br>"
                            : ""
                    }</div>`
                    : "";
            }
        },
        async addInfoBubble(map) {
            var group = new H.map.Group();

            map.addObject(group);

            // add 'tap' event listener, that opens info bubble, to the group
            group.addEventListener(
                "tap",
                (evt) => {
                    // event target is the marker itself, group is a parent event target
                    // for all objects that it contains

                    var bubble = new H.ui.InfoBubble(evt.target.getGeometry(), {
                        // read custom data
                        content: evt.target.getData(),
                    });
                    // show info bubble
                    this.ui.addBubble(bubble);
                },
                false
            );
            this.marcadores.forEach((element) => {
                this.addMarkerToGroup(
                    group,
                    element,
                    this.getHtmlpopUp(element)
                );
            });
        },
        showGeoJSONData(map) {
            // Create GeoJSON reader which will download the specified file.
            // Shape of the file was obtained by using HERE Geocoder API.
            // It is possible to customize look and feel of the objects.
            var reader = new H.data.geojson.Reader(
                `${this.url}enderecos/berlin.json`,
                {
                    // This function is called each time parser detects a new map object
                    style: function (mapObject) {
                        // Parsed geo objects could be styled using setStyle method
                        if (mapObject instanceof H.map.Polygon) {
                            mapObject.setStyle({
                                fillColor: "rgba(255, 0, 0, 0.5)",
                                strokeColor: "rgba(0, 0, 255, 0.2)",
                                lineWidth: 3,
                            });
                        }
                    },
                }
            );

            // Start parsing the file
            reader.parse();

            // Add layer which shows GeoJSON data on the map
            map.addLayer(reader.getLayer());
        },
        getLocation() {
            this.service.geocode(
                {
                    q: "Rua Josias nunes andrade,285,Ribeirópolis,Sergipe",
                },
                (result) => {
                    // Add a marker for each location found
                    var res = [result.items[0].position];
                    this.setMarker(res, this.map);
                },
                alert
            );
        },
    },
};
</script>
<style lang="css">
.H_ib_body {
    overflow: auto !important;
    max-height: 300px !important;
    width: 500px !important;
}
</style>
